import { Link, useParams } from "react-router-dom";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

import { Description } from "components";
import { Container } from "layout";
import { JobFacts } from "./JobFacts";
import { JobStatus } from "./JobStatus";
import { useJob } from "./useJob";

const JobDetailsPage = () => {
  const { id } = useParams();
  const state = useJob(id);

  if (state.status !== "ready") return <JobStatus state={state} />;
  const { job } = state;

  return (
    <Container isPage>
      <Link
        to="/"
        className="mb-6 inline-flex items-center gap-2 rounded-lg border border-orange-200 px-4 py-2 font-medium text-orange-700 hover:bg-orange-50"
      >
        <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
        All open roles
      </Link>
      <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:gap-10">
        <aside className="flex flex-col gap-6 rounded-2xl border border-orange-200 bg-orange-50 p-6 sm:p-8 lg:sticky lg:top-6 lg:w-96">
          <h1 className="text-3xl font-semibold text-gray-900 sm:text-4xl">
            {job.details.jobTitle}
          </h1>
          <JobFacts job={job.details} />
          <Link
            to={`/apply/${encodeURIComponent(job.system.id)}`}
            className="flex max-w-max items-center gap-3 rounded-lg bg-orange-500 px-5 py-3 font-medium text-white hover:bg-orange-600"
          >
            Apply now
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" />
          </Link>
        </aside>
        <article className="flex-1 rounded-3xl bg-white p-6 sm:p-8">
          <h2 className="mb-4 text-xl font-semibold text-gray-900">
            About the role
          </h2>
          <Description text={job.details.description} />
        </article>
      </div>
    </Container>
  );
};

export default JobDetailsPage;
